import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Card, CloseButton } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion'
import { BsChevronUp, BsChevronDown, BsSearch, BsX } from "react-icons/bs";
import { useState } from 'react';
import Layout from '../../components/Layout';
import LanguageContext from '../../helper/LanguageContext';
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import _ from "lodash";
import { BASE_URL, KJUUP_COLORS } from "../../helper/constants";
import { $crud } from "../../helper/CrudFactory";
import { convertBranchRole, convertCapitalLeter, convertPosition } from '../../helper/convertor';
import { BiAdjust, BiBell, BiExit, BiX, BiXCircle } from 'react-icons/bi';
import { CgClose } from 'react-icons/cg';
import { $user } from '../../helper/UserFactory';
import { useSelector } from 'react-redux';
import "./ProjectMembers.css";

function ProjectMembers(props) {
    const [viewLoader, setViewLoader] = useState(false)
    const user = useSelector((state) => state.user);
    const { isGerm, strings } = React.useContext(LanguageContext);
    const navigateUserProfile = (person) => {
        const userId = person?.id || person;
        if (!userId) return;
        requestDirectMessage({
            id: userId,
            fullName: person?.fullName,
            firstName: person?.firstName,
            lastName: person?.lastName,
            avatar: person?.avatar,
        });
    };
    // Show the current user as "Me" at the top of the room members list.
    // The /building/:id/user endpoint intentionally excludes the current user
    // from its `members` payload, so it returns the current user's own record
    // separately as `currentMember` (same shape as a member) to render an
    // accurate room position (branch, company, admin/member).
    const me = props.currentMember;
    const currentUserId = me?.id || user?.id;
    const showMe =
        !props.viewByOwner &&
        !!me &&
        !(props.searchUser && props.searchUser.trim());
    return (
        <div
            className={props.embedded ? "project-members project-members-embedded" : "project-members project-members--overlay w-300"}
        >
            {viewLoader && (
                <div className="website_loader">
                    <div className="loader" />
                </div>
            )}
            {!props.embedded && (
            <div className="company_header project-members__header">
                <div className="heading_icon m-0">
                    <a 
                        onClick={(e) => props.handleEditClose()} 
                        className={props.isInternal ? "main_heading main_heading-internal kj-pointer" : "main_heading kj-pointer"}
                    >
                        <span className="material-symbols-outlined material-arrow-left">
                          keyboard_arrow_left
                        </span>
                        {strings.room_members}
                    </a>
                </div>
            </div>
            )}
            {!props.embedded && (
            <div className="search_div project-members__search">
                <div className="search">
                    <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Control
                            autocomplete="off"
                            value={props.searchUser}
                            type="search"
                            placeholder={strings.search}
                            onChange={(e) => props.filterAdmins(e.target.value)}
                        />
                    </Form.Group>
                </div>
            </div>
            )}
            <div
                className="admin-content project-members__list"
            >
                {showMe && (
                    <div key="current-user-me">
                        <div
                            className="project-member-row project-members__row"
                        >
                            <div>
                                <div className="admin-control">
                                    <img
                                        className="m-0 project-members__avatar"
                                        width={30}
                                        height={30}
                                        src={
                                            me.avatar
                                                ? BASE_URL + me.avatar
                                                : process.env.PUBLIC_URL +
                                                "/assets/img/head.svg"
                                        }
                                        alt="Generic placeholder"
                                    />
                                </div>
                            </div>
                            <div className="project-members__info">
                                <p
                                    className="small m-0 p_user_name pointer kj-fw-500"
                                    onClick={() => navigateUserProfile(me || { id: currentUserId })}
                                >
                                    {strings.me}
                                </p>
                                <p className="m-0 small p_company">
                                    {me.companyName}
                                </p>
                                <div>
                                    <p className="m-0 small p_postion">
                                        {strings.branch}:{" "}
                                        <i>
                                            {convertBranchRole(
                                                me.buildingRole,
                                                isGerm
                                            )}
                                        </i>
                                    </p>
                                    <p className="m-0 small p_postion">
                                        {me.buldingAdmin
                                            ? strings.admin
                                            : strings.member}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {props.users?.flatMap((user, userIndex) =>
                    user.names?.map((u, i) => (
                        <div key={`${user.name}-${i}`}>
                            <div
                                className="project-member-row project-members__row"
                            >
                                <div>
                                    <div
                                        className={`admin-control${u.requestNotYetAccepted ? " project-members__pending" : ""}`}
                                    >
                                        <img
                                            className={`m-0 project-members__avatar${(u.isKjuup || u.companies?.some(c => c.isKjuup)) ? " project-members__avatar--internal" : ""}`}
                                            width={30}
                                            height={30}
                                            src={
                                                u.avatar
                                                    ? BASE_URL + u.avatar
                                                    : process.env.PUBLIC_URL +
                                                    "/assets/img/head.svg"
                                            }
                                            alt="Generic placeholder"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`project-members__info${u.requestNotYetAccepted ? " project-members__pending" : ""}`}
                                >
                                    <p
                                        className="small m-0 p_user_name pointer kj-fw-500"
                                        onClick={() =>
                                            navigateUserProfile(u)
                                        }
                                    >
                                        {u.fullName
                                            ? convertCapitalLeter(u.fullName)
                                            : ""}
                                    </p>
                                    {u.requestNotYetAccepted && (
                                        <span className="kj-text-caption">
                                            {strings.PENDING}{" "}
                                        </span>
                                    )}
                                    <p className="m-0 small p_company">
                                        {u.companyName}
                                    </p>
                                    {!u.requestNotYetAccepted && (
                                        <div>
                                            <p className="m-0 small p_postion">
                                                {strings.branch}:{" "}
                                                <i>
                                                    {convertBranchRole(
                                                        u.buildingRole,
                                                        isGerm
                                                    )}
                                                </i>
                                            </p>
                                            <p className="m-0 small p_postion">
                                                {u.buldingAdmin
                                                    ? strings.admin
                                                    : strings.member}
                                            </p>
                                        </div>
                                    )}
                                </div>
                                {(props.projectDetails?.userRole === "admin" && !props.isDone) && (
                                    <div
                                        onClick={async () => {
                                            await $crud.confirm({
                                                title: "",
                                                textContent: strings.remove_project_admin,
                                                options: {
                                                    ok: strings.confirm,
                                                    cancel: strings.cancel,
                                                },
                                            });
                                            props._deleteMemberFromProject(
                                                u.id,
                                                i,
                                                userIndex
                                            );
                                        }}
                                        className="project-members__delete"
                                    >
                                        <span
                                            className={`material-symbols-outlined delete-icon pointer ${props.isInternal ? 'delete-icon-internal' : 'delete-icon-external'}`}
                                            onClick={(e) => { }}
                                        >delete</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default ProjectMembers;
